/**
 *  layout 相关元素 id
 */
export const LAYOUT_ELEMENT_IDS = {
    menu: 'smartAdminMenu',
    main: 'smartAdminMain',
    header: 'smartAdminHeader',
    content: 'smartAdminLayoutContent',
}
